import React, { useState, useContext, useRef } from 'react';
import { getToken, delComment, editComment,  CONTENT_TYPE_COMENTARIO, RS_USER_MAIL } from "../../../services/social.services";
import CommentsContext from "../../../contexts/commentsContext";
import GlobalContext from "../../../contexts/globalContext";
import CommentReply from '../comment-reply/comment-reply';
import LikeButton from '../like-button/like-button';
import UserCard from '../social-user-card/social-user-card';
import Loading from '../../atoms/loading/loading'; 
import AttachmentCard from '../attachment-card/attachment-card';
import Button from '../../atoms/button/button';
import UrlParser from '../../atoms/url-parser/url-parser'
import { removeComment, updateComment } from '../../organisms/comment-section/comment-section';
import ModalGuiaCdc from '../../molecules/modal-guia-cdc/modalGuiaCdc';

// Styles //
import "./comment-main.scss";

const CommentMain = (props) => {

  const Context = useContext(GlobalContext);
  const [currentUserData, gigyaData, comments, setComments] = useContext(CommentsContext);
  const [replying, setReplying] = useState(false);
  const [showReplies, setShowReplies] = useState(false);
  const [isOpenEditOpts, setIsOpenEditOpts] = useState(false);
  const [isModifyingComment, setIsModifyingComment] = useState(false);
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [text, setText] = useState("");
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const editar = () => {
    setIsOpenEditOpts(false);
    setIsEditingComment(true);
    setText(props.text);
  }

  const updateCommentRemote = async () => {
    setIsModifyingComment(true);
    const token = await getToken(gigyaData.UID);
    let rqBody = {
      "contentId" : props.idContenido,
      "commentText": text,
      "attachments": []
    };
    const comentarioActualizado = await editComment(token, rqBody);
    setIsEditingComment(false);
    setIsModifyingComment(false);
    if (comentarioActualizado.data.cod == 200) {
      let newCommentList = updateComment(comentarioActualizado.data.data, comments, props.idContenido);
      setComments([...newCommentList]);
    }
    else{
      alert("Ocurrió un error al editar el comentario");
    }
  }

  const cancelarEdit = () => {
    setIsEditingComment(false);
  }

  const eliminar = async () => {
    setIsOpenEditOpts(false);
    setIsModifyingComment(true);
    const token = await getToken(gigyaData.UID);
    const response = await delComment(token, currentUserData.usermail, props.idContenido);
    setIsModifyingComment(false);
    if (response.data.cod == 200) {
      let newCommentList = removeComment(comments, props.idContenido);
      setComments([...newCommentList]);
    }
    else{
      alert("Ocurrió un error al eliminar el comentario");
   }
  }

  const ocultarCajaRespuesta = () => {
    setReplying(false);
  }

  const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

  const replyToComment = () => {
    if (!Context.gigyaContext.gigyaAccount) {
      const checkGuideCdc = localStorage.getItem("guideCdc");
      if (!checkGuideCdc){
        setIsOpenModal(true);
      } else {
          Context.gigyaContext.loginComfamaId!();
      }
    } else {
      setReplying(!replying);
    }
  }
  
  return (
    <>

      <div className="m-comment-container">

        <div className={`loading ${isModifyingComment ? "" : "hidden"}`}>
          <Loading/>
        </div>

        <div className={`m-comment-main ${isModifyingComment ? "deleted" : ""}`}>

          <div className="m-comment-box">

            <div className="comment-data">
              <div className="comment-data-opts-bar">
                <div className={`comment-data-opts ${currentUserData.usermail == RS_USER_MAIL || props.userDoc == currentUserData.userdoc ? "" : "hidden"}`} onClick={() => setIsOpenEditOpts(!isOpenEditOpts)}>...</div>
                <div className={`edit-opts ${!isOpenEditOpts ? "hidden" : ""}`}>
                  <div className="edit-opts-edit">
                    <button onClick={editar} disabled={props.userDoc != currentUserData.userdoc}>
                      <i className="icon-pencil-alt"></i> Editar
                    </button>
                  </div>
                  <hr/>
                  <div className="edit-opts-delete">
                    <button onClick={eliminar}>
                      <i className="icon-trash-alt1"></i> Eliminar
                    </button>
                  </div>
                  
                </div>
              </div>
              <div className="comment-wrapper">
                <UserCard userpic={props.userpic} username={props.username} date={props.date} />
                
                <div className="wrapper-separator">
                  <hr/>
                </div>
                <div className="comment-box-data">
                  <div className={`comment-text ${isEditingComment ? "hidden" : ""}`}>
                    {props.text.replace(/(?:\r\n|\r|\n)/g, ' <br> ').split(' ').map((s, i) => {
                      return (
                          <>
                            <UrlParser value={s} key={i} />
                          </>
                      )
                    })}
                  </div>
                  <div className={`comment-text ${isEditingComment ? "" : "hidden"}`}>
                    <textarea className="comment-text-edit"
                        ref={textAreaRef}
                        maxLength={1000}
                        value={text}
                        onChange={(event) => { setText(event.target.value); }}/>
                  </div>
                  <div className="comment-attachments">
                    {props.attachments.map((attachment, index) => (
                      <AttachmentCard key={attachment.attachmentId} editMode={isEditingComment} idComentario={props.idContenido} idAttachment={attachment.attachmentId}
                                      fileType={attachment.fileType} fileName={attachment.fileName} fileUrl={attachment.fileUrl}/>
                    ))}
                  </div>
                  <div className={`edit-buttons ${isEditingComment ? "" : "hidden"}`}>
                    <div className="bar-gap">
                    </div>
                    <div className="button-bar">
                      <div className="button-bar-guardar">
                          <Button
                          type="button"
                          text="GUARDAR"
                          classname="a-button__magenta"
                          href={void(0)}
                          isDisabled={text.length < 1}
                          onClickAction={updateCommentRemote}/>
                      </div>
                      <div className="button-bar-cancelar">
                          <Button
                          type="button"
                          text="CANCELAR"
                          classname="a-button primary"
                          href={void(0)}
                          onClickAction={cancelarEdit}/>
                      </div>
                    </div>
                </div>
                </div>
              </div>
            </div>

            <div className="social-data">
              <div className="social-data-left">
                <div className="social-data-likes">
                  <LikeButton textoBoton="Me gusta" soloContador={true} contentId={props.idContenido} contentType={CONTENT_TYPE_COMENTARIO}/>
                </div>
                <div className="social-data-reply">
                  <button onClick={() => { replyToComment() }}>Responder</button>
                </div>
              </div>
              <div className="social-data-right">
                <div className="social-data-reply-cnt">
                  <button onClick={() => setShowReplies(!showReplies)}>{props.replies.length == 0 ? "" : `${props.replies.length} respuesta${props.replies.length == 1 ? "" : "s"}`}</button>
                </div>
              </div>
            </div>

          </div>
          
          <CommentReply isHidden={ replying ? "" : "hidden" } fnHide={ocultarCajaRespuesta} replyingTo={props.username} parentContentType={CONTENT_TYPE_COMENTARIO} parentContentId={props.idContenido} grandParentContentId={props.idGrandParent == null ? props.idContenido : props.idGrandParent}/>

          <div className={`m-comment-replies ${showReplies ? "" : "hidden"}`}>
            {getComments(props.replies, props.idContenido)}
          </div>
        
        </div>
        
      </div>
      {isOpenModal && (
        <ModalGuiaCdc showModal={isOpenModal} onClose={closeModal}/>
      )}
    </>
  );

}
  
export default CommentMain;

function getComments(comments, grandParentContentId) {
    return comments.map((comment, i) => {
      return (
        <CommentMain
          idContenido={comment.idContenido}
          idGrandParent={grandParentContentId}
          userDoc={comment.userdoc}
          usermail={comment.usermail}
          username={comment.username}
          userpic={comment.userpic}
          date={comment.dateEdit}
          text={comment.text}
          likes={comment.likes}
          attachments={comment.attachments}
          replies={comment.replies}
          key={i}
        />
      );
    });
}

export {getComments};